// If there is an external url file uncomment below and replace main url with the import
// import url from ''

const mainUrl = 'https://bookings.olpejetaconservancy.org:9000/'
const amuraUrl = 'https://bookings.olpejetaconservancy.org:9000/v1/'
// const amuraUrl = 'https://4726-41-215-76-14.ngrok.io /v1/'


export const LogUrls = {
  postLog: mainUrl + 'post',
  getAllLogs: mainUrl + 'requests/view',
  getLog: mainUrl + 'get_single',
  editLog: mainUrl + 'update',
  getDeletedLogs: mainUrl + 'delete',
  deleteLog: mainUrl + 'delete',
  authLogs: amuraUrl + 'fetch/logs',
  _featureLogs: amuraUrl + 'fetch/feature/logs',
  _passwordResetLogs: amuraUrl + 'password/resets',
  postChangeLog: amuraUrl + 'add/change-log',
  getChangeLog: amuraUrl + 'fetch/change-logs',
  getSingleChangeLog: amuraUrl + 'fetch/single-changelog',
  saveSystemLogs: amuraUrl + 'save/log',
}
